"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
function bindExportedProviderRefToContainer(exportedProviderRef, container) {
    container
        .bind(exportedProviderRef.provide)
        .toDynamicValue(exportedProviderRef.getValue)
        .whenTargetTagged(constants_1.IMPORTED_TAG, true);
}
exports.default = bindExportedProviderRefToContainer;
